export function getCourierAppUrl() {
  const hostname = window.location.hostname
  return hostname === 'localhost' || hostname === '127.0.0.1'
    ? `http://${hostname}:5175/app/`
    : 'https://entregador.canhotosimples.com.br/app/'
}

export function openCourierApp() {
  // Each app authenticates on its own origin. Never put credentials in the URL.
  window.location.assign(getCourierAppUrl())
}
